<div class="container">
  <div class="page-header-title" i18n>Content overview</div>
  @if (totalCount !== null) {
    <div class="page-sub-header">{{ totalCount }} <ng-container i18n>created content</ng-container></div>
  }

  <div class="content-card-background">
    <div class="header-row">
      <select class="template-select header-select" [formControl]="templateSelect">
        <option selected [ngValue]="null" i18n>All templates</option>
        @for (item of templateQueryItems; track item.type + ':' + item.id) {
          <option [ngValue]="item">{{ item.title }}</option>
        }
      </select>
      <select class="type-select header-select" [formControl]="selection">
        <option selected [ngValue]="null">All</option>
        <option [ngValue]="ImageTypeEnum.GIF">GIF</option>
        <option [ngValue]="ImageTypeEnum.Video">Video</option>
        <option [ngValue]="ImageTypeEnum.Image">Image</option>
      </select>

      <div>
        <select class="month-select header-select" [formControl]="monthSelection">
          @for (option of specificTimeSelections; track option) {
            <option [ngValue]="option">{{ option.title }}</option>
          }
          <option [ngValue]="null" i18n>All</option>
        </select>
      </div>

      <select [formControl]="first" class="paging-select">
        <option [ngValue]="24">24</option>
        <option [ngValue]="48">48</option>
        <option [ngValue]="96">96</option>
      </select>
    </div>

    @if (content.length < 1 && loading === false) {
      <h4 class="no-content" i18n>No content found</h4>
    }

    @for (item of content; track item.id) {
      <li class="content-row">
        <a
          class="content-link"
          [attr.aria-disabled]="item.deleted !== null"
          [routerLink]="!item.deleted ? ['/content/' + item.id] : null"
          [class.disabled]="item.deleted !== null">
          <div class="content-icon-bg" [class.grey-bg]="item.deleted !== null">
            @switch (item.type) {
              @case (ImageTypeEnum.Video) {
                <i class="fas fa-play-circle content-icon" [class.black]="item.deleted !== null"></i>
              }
              @case (ImageTypeEnum.Image) {
                <i class="far fa-image-polaroid content-icon" [class.black]="item.deleted !== null"></i>
              }
              @case (ImageTypeEnum.GIF) {
                @if (item.deleted === null) {
                  <img src="assets/icons/gif.svg" class="content-icon" alt="" />
                } @else {
                  <img src="assets/icons/gif-black.svg" class="content-icon" alt="" />
                }
              }
            }
          </div>
          <div class="content-details">
            <div class="content-details-top">
              <h3 class="content-details-title" [class.deleted]="item.deleted !== null">{{ item.title }}</h3>
            </div>
            <div class="content-details-bottom">
              @if (item.templateItem.template.items.length === 1) {
                <p [class.deleted]="item.deleted !== null">
                  {{ item.templateItem.template.title }} &nbsp; | &nbsp; {{ item.views.totalCount }} Views
                </p>
              } @else {
                <p [class.deleted]="item.deleted !== null">
                  {{ item.templateItem.template.title }} / {{ item.templateItem.title }} &nbsp; | &nbsp; &nbsp;
                  {{ item.views.totalCount }} Views
                </p>
              }
            </div>
          </div>
        </a>
        @if (item.deleted === null) {
          <div registerMenuToggle (clickedOutside)="activeDropdown[item.id] = false" class="content-row-menu">
            <div class="content-options-button" (click)="activeDropdown[item.id] = !activeDropdown[item.id]">
              <i class="fas fa-ellipsis-v"></i>
            </div>
            @if (activeDropdown[item.id] === true) {
              <div class="content-options-dropdown">
                <button class="dropdown-button delete-button" (click)="deleteContent(item.id)">
                  <i class="far fa-times-circle"></i>
                  <ng-container i18n>Delete item</ng-container>
                </button>
                <a class="dropdown-button report-button clean-link" routerLink="/reports" [queryParams]="{ contentId: item.id }">
                  <i class="far fa-chart-line"></i>
                  <ng-container i18n>View report</ng-container>
                </a>
              </div>
            }
          </div>
        } @else {
          <div class="content-deleted-wrapper">
            <i class="fas fa-times-circle"></i>
            <p i18n>Item deleted</p>
          </div>
          <div class="content-row-deleted">
            <p i18n>Reason: {{ item.deletedReason }}</p>
          </div>
        }
      </li>
    }

    @if (pageCount > 1) {
      <div class="footer-pager-row">
        <button (click)="previousPage()" [disabled]="offset.value <= 1" class="skideo-flat-button black img-left">
          <i class="fas fa-arrow-left next-page-button-icon"></i>
          <ng-container i18n>Previous page</ng-container>
        </button>
        <select [formControl]="offset">
          @for (number of pages; track number) {
            <option>{{ number + 1 }}</option>
          }
        </select>
        <button (click)="nextPage()" [disabled]="offset.value >= pageCount" class="skideo-flat-button black img-right">
          <ng-container i18n>Next page</ng-container>
          <i class="fas fa-arrow-right next-page-button-icon"></i>
        </button>
      </div>
    }
  </div>
</div>
